// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__36tyD","buttons":"PendingPaymentAlert_buttons__nqugw"};